import { all, call, put, select, takeEvery, takeLatest } from "redux-saga/effects";

import {
    FORUM_SEARCH,
    FORUM_SEARCH_SAVE,
    ForumSearchAction,
    ForumSearchSaveAction,
    forumSearchApi,
} from "@/mk2/apps/forum/containers/ForumSearch/ForumSearch.actions";
import { forumSearchUrl } from "@/mk2/apps/forum/urls";
import { XHRAction, normalizeError } from "@/mk2/helpers/api";
import { url } from "@/mk2/helpers/urls";
import { getLogger } from "@/mk2/logger";
import { HistoryAction, pushInPWA, replaceInPWA } from "@/mk2/services/browserHistory";
import { forum_api_search_url } from "@/mk/urls/functions";

const logger = getLogger("forum/ForumSearch.sagas");

/**
 * Save query in the database for later statistics and analytics
 * @param {any} query
 * @param {any} xhr
 */
function* saveSearch({ query, xhr }: ForumSearchSaveAction & XHRAction) {
    yield put(forumSearchApi.request(query));

    try {
        const response = yield call(() => xhr.post(forum_api_search_url(), { query }));
        const normalizedResponse = {};
        yield put(forumSearchApi.success(query, normalizedResponse));
    } catch (error) {
        logger.error(error);
        yield put(forumSearchApi.failure(query, normalizeError(error)));
    }
}

function search({ query, location, history }: ForumSearchAction & HistoryAction) {
    // Update URL
    const gotoUrl = url(forumSearchUrl, {}, query ? { q: query } : undefined);
    if (/\/search\//.test(location.pathname)) {
        replaceInPWA(history, gotoUrl);
    } else {
        pushInPWA(history, forumSearchUrl);
    }
}

export default function* root() {
    yield all([takeLatest(FORUM_SEARCH, search), takeEvery(FORUM_SEARCH_SAVE, saveSearch)]);
}
